import Image from 'next/legacy/image';

import { BodySmall } from '@common/body';
import DownArrow from '@common/Icons/DownArrow';
import { H3 } from '@common/headline';

import mounjaroWeightLossDesktop from '@public/img/medically-supported/mounjaro-weight-loss-medication-supported-desktop.png';
import mounjaroWeightLossMobile from '@public/img/medically-supported/mounjaro-weight-loss-medication-supported-mobile.png';

export const MounjaroMedicationSupportedWeightLoss = (): JSX.Element => (
  <div className="flex w-full justify-center bg-dawn-blue-100 px-3 pb-16 pt-14 lg:px-[60px] lg:py-[110px]">
    <div className="flex w-[341px] flex-col-reverse items-center justify-center gap-x-[136px] gap-y-14 lg:w-full lg:flex-row">
      <div className="text-blue-600 lg:hidden">
        <div className="relative h-[341px] w-full overflow-hidden">
          <Image
            alt="Weight-loss comparison"
            layout="fill"
            objectFit="contain"
            src={mounjaroWeightLossMobile}
          />
        </div>
        <div className="mt-12">
          <BodySmall>
            Wilding JPH, Batterham RL, Calanna S, et al. Once-Weekly Semaglutide
            in Adults with Overweight or Obesity. N Engl J Med. 2021 Feb 10.
            doi: 10.1056/NEJMoa2032183. Epub ahead of print. PMID: 33567185.
          </BodySmall>
        </div>
      </div>
      <div className="relative hidden flex-none overflow-hidden lg:block">
        <Image
          alt="Weight-loss comparison"
          height={341}
          src={mounjaroWeightLossDesktop}
          width={427}
        />
      </div>
      <div className="max-w-[580px]">
        <div className="text-purple">
          <H3>Weight-loss results</H3>
        </div>
        <div className="mt-4 stroke-blue text-blue">
          <H3>
            <span className="m-[-0.1em] inline-block h-[20px] lg:h-[27px]">
              <DownArrow display="inline" strokeWidth={3} />
            </span>{' '}
            Up to 20-25% reduction in body weight by month 12
          </H3>
        </div>
        <div className="mt-12 hidden text-blue-600 lg:block">
          <BodySmall>
            Aronne LJ, Sattar N, Horn DB, et al. Continued Treatment With
            Tirzepatide for Maintenance of Weight Reduction in Adults With
            Obesity: The SURMOUNT-4 Randomized Clinical Trial. JAMA.
            2024;331(1):38-48. doi:10.1001/jama.2023.24945
          </BodySmall>
        </div>
      </div>
    </div>
  </div>
);
